module.exports = __webpack_public_path__ + "img/17fda676ba598341e62c591883c020ad.png";